define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,Ref,reflection,xml,Query) {

	return declare(Ref, {
		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			var quoteRev = ctx.getNode();

			var pathToProductSourcing = "Child:__Parent__/Child:__Parent__/Child:__Parent__";
			//Requires: Cache the ProductSourcing node by CostScenario.CostScenarioForm#_getRootRequest
			var productSourcingNode = ctx.cache.getPathNode(quoteRev, pathToProductSourcing);
			var	query = new Query();
			var	q = query.Attr("State", xml.OP_NOT_EQUALS, reflection.REVISION_ABANDONED, "Child:CurrentRevision");

			if (productSourcingNode) {
				// productNode can be null for SupplierItem template
				q = q.Or();
				q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, productSourcingNode.__Parent__);
			}

			q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, "centric://REFLECTION/INSTANCE/SiteLibSupplierItem/SiteLibSupplierItem");

			return lang.mixin(new Action(), {
				m_fixedQuery: query,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "AggregateRouting",
					m_url: "centric://APPAREL/SizeChartAdmin"
				})
			});
		}
	});
});